import { takeLatest } from "redux-saga/effects"

import { apiGeneratorBase, apiGeneratorDelete } from "../../Utils/saga"
import { getStatisticsAdmin } from "../BusinessAccountsPage/redux/businessAccounts.thunks"
import Creators, { CreditsTypes as constants } from "./reducer"
import * as services from "./services"

const actions = {
  getCreditsStatisticsActions: {
    request: Creators.getCreditsStatisticsRequest,
    success: Creators.getCreditsStatisticsSuccess,
    errors: Creators.getCreditsStatisticsFailure
  },
  getCreditsFilterOptionsActions: {
    request: Creators.getCreditsFilterOptionsRequest,
    success: Creators.getCreditsFilterOptionsSuccess,
    errors: Creators.getCreditsFilterOptionsFailure
  },
  getCreditsActions: {
    request: Creators.getCreditsRequest,
    success: Creators.getCreditsSuccess,
    errors: Creators.creditsFailure
  },
  updateCreditActions: {
    request: Creators.updateCreditRequest,
    success: Creators.updateCreditSuccess,
    errors: Creators.creditsFailure,
    extraAction: [getStatisticsAdmin]
  },
  pinCreditActions: {
    request: Creators.pinCreditRequest,
    success: Creators.pinCreditSuccess,
    errors: Creators.creditsFailure
  },
  deleteCreditActions: {
    request: Creators.deleteCreditRequest,
    success: Creators.deleteCreditSuccess,
    errors: Creators.creditsFailure,
    extraAction: [getStatisticsAdmin]
  },
  getCreditsOtherPageActions: {
    request: Creators.getCreditsOtherPageRequest,
    success: Creators.getCreditsOtherPageSuccess,
    errors: Creators.creditsFailure
  },
  getCreditsExportActions: {
    request: Creators.getCreditsExportRequest,
    success: Creators.getCreditsExportSuccess,
    errors: Creators.getCreditsExportFailure
    //downloadFile: true,
  },
  getCreditDetailsActions: {
    request: Creators.getCreditDetailsRequest,
    success: Creators.getCreditDetailsSuccess,
    errors: Creators.getCreditDetailsFailure
    //fakeData: fakeDetailsData,
  },
  attachProofCreditActions: {
    request: Creators.attachProofCreditRequest,
    success: Creators.attachProofCreditSuccess,
    errors: Creators.attachProofCreditFailure
  },
  resubmitCreditRequestActions: {
    request: Creators.resubmitCreditRequestRequest,
    success: Creators.resubmitCreditRequestSuccess,
    errors: Creators.creditsFailure
  }
}

const eventsOptions = {
  [constants.GET_CREDITS_STATISTICS_REQUEST]: {
    api: services.getCreditsStatistics,
    actions: actions.getCreditsStatisticsActions
  },
  [constants.GET_CREDITS_FILTER_OPTIONS_REQUEST]: {
    api: services.getCreditsFilterOptions,
    actions: actions.getCreditsFilterOptionsActions
  },
  [constants.GET_CREDITS_REQUEST]: {
    api: services.getCredits,
    actions: actions.getCreditsActions
  },
  [constants.UPDATE_CREDIT_REQUEST]: {
    api: services.updateCredit,
    actions: actions.updateCreditActions
  },
  [constants.PIN_CREDIT_REQUEST]: {
    api: services.pinCredit,
    actions: actions.pinCreditActions
  },
  [constants.DELETE_CREDIT_REQUEST]: {
    api: services.deleteCredit,
    actions: actions.deleteCreditActions
  },
  [constants.GET_CREDITS_OTHER_PAGE_REQUEST]: {
    api: services.getCreditsOtherPage,
    actions: actions.getCreditsOtherPageActions
  },
  [constants.GET_CREDITS_EXPORT_REQUEST]: {
    api: services.getCreditsExport,
    actions: actions.getCreditsExportActions
  },
  [constants.GET_CREDIT_DETAILS_REQUEST]: {
    api: services.getCreditDetails,
    actions: actions.getCreditDetailsActions
  },
  [constants.ATTACH_PROOF_CREDIT_REQUEST]: {
    api: services.attachProofCredit,
    actions: actions.attachProofCreditActions
  },
  [constants.RESUBMIT_CREDIT_REQUEST_REQUEST]: {
    api: services.resubmitCreditRequest,
    actions: actions.resubmitCreditRequestActions
  }
}

export default function* apiSaga() {
  yield takeLatest(constants.GET_CREDITS_STATISTICS_REQUEST, (action) =>
    apiGeneratorBase(action, eventsOptions[constants.GET_CREDITS_STATISTICS_REQUEST])
  )
  yield takeLatest(constants.GET_CREDITS_FILTER_OPTIONS_REQUEST, (action) =>
    apiGeneratorBase(action, eventsOptions[constants.GET_CREDITS_FILTER_OPTIONS_REQUEST])
  )
  yield takeLatest(constants.GET_CREDITS_REQUEST, (action) =>
    apiGeneratorBase(action, eventsOptions[constants.GET_CREDITS_REQUEST])
  )
  yield takeLatest(constants.UPDATE_CREDIT_REQUEST, (action) =>
    apiGeneratorBase(action, eventsOptions[constants.UPDATE_CREDIT_REQUEST])
  )
  yield takeLatest(constants.PIN_CREDIT_REQUEST, (action) =>
    apiGeneratorBase(action, eventsOptions[constants.PIN_CREDIT_REQUEST])
  )
  yield takeLatest(constants.DELETE_CREDIT_REQUEST, (action) =>
    apiGeneratorDelete(action, eventsOptions[constants.DELETE_CREDIT_REQUEST])
  )
  yield takeLatest(constants.GET_CREDIT_DETAILS_REQUEST, (action) =>
    apiGeneratorBase(action, eventsOptions[constants.GET_CREDIT_DETAILS_REQUEST])
  )
  yield takeLatest(constants.GET_CREDITS_EXPORT_REQUEST, (action) =>
    apiGeneratorBase(action, eventsOptions[constants.GET_CREDITS_EXPORT_REQUEST])
  )
  yield takeLatest(constants.ATTACH_PROOF_CREDIT_REQUEST, (action) =>
    apiGeneratorBase(action, eventsOptions[constants.ATTACH_PROOF_CREDIT_REQUEST])
  )
  yield takeLatest(constants.RESUBMIT_CREDIT_REQUEST_REQUEST, (action) =>
    apiGeneratorBase(action, eventsOptions[constants.RESUBMIT_CREDIT_REQUEST_REQUEST])
  )
}
